import axios from '../../plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async fetch({ commit }, { filter = {}, sorting = null }) {
            const { data } = await axios.get('/admin/payments', { params: { filter, sorting } });
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { id }) {
            const { data } = await axios.get(`/admin/payments/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }) {
            let response = {};
            if(state.entity._id) {
                response = await axios.put(`/admin/payments/${ state.entity._id }`, state.entity);
            } else {
                response = await axios.post('/admin/payments', state.entity);
            }
        },
        async setStatus({ commit, state }, { id, status }) {
            await axios.put(`/admin/payments/status/${ id }/${ status }`);
        },
        async delete({ commit }, { id }) {
            await axios.delete(`/admin/payments/${ id }`);
        },
    },

    getters: {}
}
